<template>
   <div>
        <b-row class="toolbar-ptc">
            <b-col>
            </b-col>
            <b-col class="text-center title">會員管理 / 會員補點</b-col>
            <b-col>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-card class="bg-default-card" v-show="FunctionPermission===4">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="p-4 box-shadow" header="Form Elements">
                            <div class='table-responsive'>
                                <div class='row col-lg-12'>
                                    <div class='form-group col-lg-3 p-10'>
                                        <label class='control-label' for='number'>
                                            客戶手機:<span style='color:red;' v-if="model.phonetype">請輸入正確手機號碼</span>
                                        </label>
                                        <div>
                                            <input type='phone' v-model='model.mobile' class='form-control' id='mobile' placeholder='手機號碼' v-on:keyup="check_count($event)">
                                        </div>
                                    </div>
                                    <div class='col-lg-1 mt-3'>
                                        <button type='button' class='btn btn-ptc1 mt-3' @click='getmemberone(model.mobile)'>查詢</button>
                                    </div>
                                </div>
                                <div class='row col-lg-12'>
                                    <div class='form-group col-lg-3 p-10'>
                                        <label class='control-label' for='number'>
                                            目前總點數:
                                        </label>
                                        <div>
                                            <input type='text' v-model='this.model.fistpoint' class='form-control' id='name' name='name' disabled>
                                        </div>
                                    </div>
                                    <div class='form-group col-lg-2 p-10'>
                                        <label class='control-label' for='number'>
                                            客戶姓名:
                                        </label>
                                        <div>
                                            <input type='text' v-model='model.name' class='form-control' id='name' name='name' disabled>
                                        </div>
                                    </div>
                                    <div class='form-group col-lg-2 p-10'>
                                        <label class='control-label' for='number'>
                                            客戶狀態:
                                        </label>
                                        <div>
                                            <input type='text' v-model='model.status' class='form-control' id='status' name='status' disabled>
                                        </div>
                                    </div>
                                    <div class='form-group col-lg-2 p-10'>
                                        <label class='control-label' for='number'>
                                            客戶等級:
                                        </label>
                                        <div>
                                            <input type='text' v-model='model.level' class='form-control' id='status' name='status' disabled>
                                        </div>
                                    </div>
                                    <div class='form-group col-lg-2 p-10'>
                                        <label class='control-label' for='number'>
                                            性別:
                                        </label>
                                        <div>
                                            <input type='text' v-model='model.gender' class='form-control' id='status' name='status' disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-lg-12">
                                    <div class='form-group col-lg-3 p-10'>
                                        <label class='control-label' for='number'>
                                            補充點數:
                                        </label>
                                        <div>
                                            <input type='number' class='form-control' id='point' name='point' max="1000" min="-10s00" v-model='model.point' placeholder='0' @change="changePoint(model.point)">
                                        </div>
                                    </div>
                                    <span class="mt-5" style="color:red">補點限制範圍為 -1000 ~ 1000</span>
                                    <div class='form-group col-lg-3 p-10'>
                                        <label class='control-label' for='number'>
                                          品牌:
                                        </label>
                                        <div>
                                          <select
                                            name="queryBrandsCode"
                                            class="form-control"
                                            v-model="model.queryBrandsCode"
                                          >
                                          <option v-bind:value="''" :key="''">總部</option>
                                          <option
                                            v-for="x in selectListBrands"
                                            v-bind:value="x.Code"
                                            :key="x.Code"
                                          >{{x.Text}}</option>
                                          </select>
                                        </div>
                                    </div>
                                </div>
                                <div class='form-group p-10'>
                                    <label class='control-label col-md-4' for='season'>原因:</label>
                                    <div class='col-md-9'>
                                        <textarea rows='4' class='form-control resize_vertical' id='reason' name='reason' v-model='model.reason' placeholder='請輸入補點原因' ></textarea>
                                    </div>
                                </div>
                                <div class='row col-lg-10'>
                                    <button type='button' class='btn btn-normal-ptc1 broder' @click='editcontact()'>新增補點點數</button>
                                    <span class='mt-2 col-lg-8' style='color:red;'>{{model.extext}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
            <b-card class="bg-default-card">
              <div class="row">
                  <div class="col-lg-12">
                      <div class="p-4 box-shadow" header="Form Elements">
                        <div class="text-left">
                            <div class="row">
                              <div class="col-md-4" id="search-input-container">
                                  <label>
                                      <input type="search" id="search-input" class="form-control mb-2" placeholder="關鍵字(手機號碼、補點原因、異動人員)" v-model="model1.searchtext">
                                  </label>
                              </div>
                              <div class="col-md-8 mt-2">
                                <div class="form-group p-10 row">
                                    <div class="col-2 mb-2">性別：</div>
                                    <div class="col-lg-2 col-md-2">
                                        <div class="custom-controls-stacked">
                                            <input class="radiobox-boom" v-model="model1.gender" type="radio" name="gender" value="0"> 全部
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-2">
                                        <div class="custom-controls-stacked">
                                            <input class="radiobox-boom" v-model="model1.gender" type="radio" name="gender" value="male"> 男
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-2">
                                        <div class="custom-controls-stacked">
                                            <input class="radiobox-boom" v-model="model1.gender" type="radio" name="gender" value="female"> 女
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-2">
                                        <div class="custom-controls-stacked">
                                            <input class="radiobox-boom" v-model="model1.gender" type="radio" name="gender" value="private"> 不公開
                                        </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div class="row col-lg-12 mt-2">
                                  <label class="control-label mt-1">日期區間：</label>
                                  <div class="col-md-3">
                                      <input type="date" class="form-control" v-model="model1.sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                                  </div>
                                  <label class="mt-1">至</label>
                                  <div class="col-md-3">
                                      <input type="date" class="form-control" v-model="model1.edate" max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                                  </div>
                                  <div class="col-md-3">
                                      <button type="button" class="btn btn-warning text-white" @click='Search()'>查詢</button>
                                      <button type="button" class="btn btn-warning text-white"  @click='Reset()'>重設</button>
                                      <button type="button" class="btn btn-warning text-white"  @click='exportFile()'>匯出</button>
                                  </div>
                                  <div class="float-right mt-1">
                                      <label>總筆數:{{model1.totalrows}}</label>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
                            <thead>
                                <tr>
                                    <th width="8%">品牌</th>
                                    <th width="12%">會員手機</th>
                                    <th width="10%">會員名稱</th>
                                    <th width="5%">性別</th>
                                    <th width="8%">補點前點數</th>
                                    <th width="6%">補點點數</th>
                                    <th width="8%">補點後點數</th>
                                    <th width="20%">補點原因</th>
                                    <th width="8%">異動人員</th>
                                    <th width="15%">異動時間</th>
                                </tr>
                                <tr v-for="v in Datalist" :key="v.id">
                                    <td width="8%">{{v.BrandCode}}</td>
                                    <td width="12%">{{v.MemberMobile}}</td>
                                    <td width="10%">{{v.MemberName}}</td>
                                    <td width="5%">{{(v.Gender == 'male') ? '男': (v.Gender == 'female') ? '女': (v.Gender == 'private') ? '不公開': ''}}</td>
                                    <td width="8%">{{v.PreviousTotalBonus}}</td>
                                    <td width="6%">{{v.Bonus}}</td>
                                    <td width="8%">{{v.TotalBonus}}</td>
                                    <td width="20%">{{v.TransactionComment}}</td>
                                    <td width="8%">{{v.UpUserName}}</td>
                                    <td width="15%">{{v.UpdatedAt|formatDate}}</td>
                                </tr>
                            </thead>
                        </table>
                        <div>
                            <div class="row" style="padding: 0 1rem">
                                <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getmemberchangepointlist"></b-pagination>
                                <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                            </div>
                        </div>
                        <!--確認補點子視窗-->
                        <b-modal ref="editcontact" hide-footer title="補點確認" size="lg">
                            <div class="d-block">
                                <div class="col-lg-12 col-12 mb-3">
                                    <!-- <vue-form class="form-horizontal form-validation" :state="formstate1"> -->
                                        <div>
                                            <div class="row col-lg-12">
                                                <label>客戶手機：</label>
                                                <label>{{model.mobile}}</label>
                                            </div>
                                            <div class="row col-lg-12">
                                                <label>客戶姓名：</label>
                                                <label>{{model.name}}</label>
                                            </div>
                                            <div class="row col-lg-12">
                                                <label>性別：</label>
                                                <label>{{model.gender}}</label>
                                            </div>
                                            <div class="row col-lg-12">
                                                <label>客戶狀態：</label>
                                                <label>{{model.status}}</label>
                                            </div>
                                            <div class="row col-lg-12">
                                                <label>補充點數：</label>
                                                <label>{{model.point}}</label>
                                            </div>
                                            <div class="row col-lg-12">
                                                <label>品牌：</label>
                                                <label>{{model.queryBrandsCode!='' ? model.queryBrandsCode : '總部'}}</label>
                                            </div>
                                            <div>
                                                <label for='season'>原因：</label>
                                                <textarea rows='4' class='form-control resize_vertical' id='reason' name='reason' v-model='model.reason' placeholder='請輸入補點原因' disabled></textarea>
                                            </div>
                                        </div>
                                    <!-- </vue-form> -->
                                </div>
                                <div class="cog-lg-12">
                                    <div class="row float-right cog-lg-12">
                                        <b-btn variant="primary"  @click="CheckUser()">儲存</b-btn>&nbsp;
                                        <b-btn variant="secondary"  @click="cancel()">取消</b-btn>&nbsp;
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                        <!--用戶確認視窗-->
                        <b-modal ref="checkuser" hide-footer title="請輸入使用者密碼" size="lg">
                            <div class="d-block">
                                <div class="col-lg-12 col-12 mb-3">
                                  <div class="row col-lg-12">
                                      <label>使用者密碼：</label>
                                      <input type='password' v-model='model.ch_password' class='form-control' splaceholder='請輸入使用者密碼' >
                                  </div>
                                </div>
                                <div class="cog-lg-12">
                                    <span style='color:red;' v-if="passwordtext != ''">{{passwordtext}}</span>
                                    <div class="row float-right cog-lg-12">
                                        <b-btn variant="primary"  @click="Add()">儲存</b-btn>&nbsp;
                                        <b-btn variant="secondary"  @click="cancel()">取消</b-btn>&nbsp;
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                      </div>
                  </div>
              </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import { mapGetters } from 'vuex'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
miniToastr.init()
Vue.use(ClientTable, {}, false)
export default {
  formstate1: {},
  name: 'simple_tables',
  computed: mapGetters({
    // 取得 loading state
    loading: 'getLoading'
  }),
  data () {
    return {
      effect_type: 2,
      effect_year: 1,
      org_type: '',
      org_year: '',
      show_edit2: true,
      show_save: false,
      show_cancel4: false,
      rdo_effect: true,
      txt_effect: true,
      addModal: false,
      new_level: '',
      new_point: '',
      edit_level: '',
      edit_point: '',
      searchInput: '',
      gender: '0',
      item: {},
      search: '',
      rows: 0,
      totalpage: 0,
      sdateInvalid: false,
      edateInvalid: false,
      model: {
        mobile: '',
        omobile: '',
        name: '',
        status: '',
        point: 0,
        fistpoint: 0,
        lostpoint: 0,
        reason: '',
        extext: '',
        blacktype: false,
        level: '',
        ch_password: '',
        phonetype: false,
        queryBrandsCode: '',
      },
      member: [],
      model1: {
        searchtext: '',
        gender: '0',
        sdate: '',
        edate: '',
        currentPage: 1,
        totalrows: 0,
        rows: 20,
        startRowNum: 0,
        endRowNum: 0
      },
      curSearchResult: {
        hasResult: false,
        keyword: '',
        gender: '0',
        startDate: '',
        endDate: ''
      },
      Datalist: [],
      FunctionPermission: 0,
      selectListBrands: [], // 品牌下拉選單
    }
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    Search (phone) {
      this.model1.currentPage = 1
      this.getmemberchangepointlist(1)
    },
    Add () {
      if (this.$parent.Loading === true) {
        return
      }
      this.$parent.Loading = true
      this.passwordtext = ''
      return axios.post(API_URL + '/web/member/makeupmembertransaction/v1', {
        password: this.model.ch_password,
        member: this.member,
        point: this.model.point,
        comment: this.model.reason,
        brandCode: this.model.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.model = {
              mobile: '',
              omobile: '',
              name: '',
              status: '',
              point: 0,
              gender: '',
              reason: '',
              extext: '',
              blacktype: false,
              ch_password: '',
              brandCode:''
            }
            this.$refs.checkuser.hide()
            miniToastr.success('新增補點成功')
            this.setdate()
            this.getmemberchangepointlist(1)
            this.$refs.editcontact.hide() // 20200422 tina add
          } else if (response.data.result === '0101') {
            miniToastr.error('密碼錯誤')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '新增補點失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error(error.message, '新增補點失敗')
        })
    },
    editcontact () {
      if (this.model.mobile === undefined || this.model.mobile === '') {
        this.model.extext = '請輸入手機號碼'
        return
      } else if (this.member.length === 0) {
        this.model.extext = '請點擊查詢'
        return
      } else if (this.model.status !== '正常') {
        this.model.extext = '黑名單不可補點'
        return
      } else if (this.model.point === 0) {
        this.model.extext = '請輸入補點點數'
        return
      } else if (this.model.reason === null || this.model.reason === '') {
        this.model.extext = '請輸入補點原因'
        return
      } else if (this.model.reason.length > 128) {
        this.model.extext = '字數限制最長128字'
        return
      }
      this.model.extext = ''
      this.model.ch_password = ''
      this.passwordtext = ''
      this.$refs.editcontact.show()
    },
    cancel () {
      this.$refs.editcontact.hide()
      this.$refs.checkuser.hide()
    },
    chkDateRangeInOneYear (sdate, edate) {
      const startDate = new Date(sdate)
      const endDate = new Date(edate)
      const difference = endDate.valueOf() - startDate.valueOf()
      const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000
      if (difference <= oneYearInMilliseconds) {
        return true
      } else {
        return false
      }
    },
    resetCurSearchResult () {
      this.curSearchResult.keyword = ''
      this.curSearchResult.gender = '0'
      this.curSearchResult.startDate = ''
      this.curSearchResult.endDate = ''
    },
    getmemberchangepointlist (currentPage) {
      var edate = new Date().toISOString().slice(0, 10) // today in format 'YYYY-MM-DD'
      if (this.model1.edate !== '') {
        edate = this.model1.edate
      }
      if (this.model1.sdate > edate) {
        miniToastr.success('請選擇正確的效期區間')
        return
      }
      if (this.sdateInvalid || this.edateInvalid) {
        miniToastr.error('日期格式輸入錯誤，請重新輸入')
        return
      }
      if (!this.chkDateRangeInOneYear(this.model1.sdate, edate)) {
        miniToastr.error('日期範圍須為一年內')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/memberchangepointlist/v1', {
        keyword: this.model1.searchtext,
        gender: this.model1.gender,
        startdate: this.model1.sdate,
        enddate: edate,
        toPage: currentPage,
        perPage: this.model1.rows
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.model1.totalrows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.Datalist = response.data.memberchangepointlist
            this.model1.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.model1.rows * (this.model1.currentPage - 1) + 1
            this.model1.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.model1.rows > response.data.totalRows) ? response.data.totalRows : (this.model1.currentPage * this.model1.rows) >= response.data.totalRows ? response.data.totalRows : this.model1.currentPage * this.model1.rows
            // 紀錄目前有效查詢之值用以匯出報表
            this.curSearchResult.hasResult = true
            this.curSearchResult.keyword = this.model1.searchtext
            this.curSearchResult.gender = this.model1.gender
            this.curSearchResult.startDate = this.model1.sdate
            this.curSearchResult.endDate = edate
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error(error.message, '查詢失敗')
        })
    },
    exportFile () {
      if (!this.curSearchResult.hasResult) {
        miniToastr.error('請先查詢產生有效結果')
      }
      this.$parent.Loading = true
      axios.post(API_URL + '/web/memberchangepointlist/download/v1', {
        keyword: this.curSearchResult.keyword,
        gender: this.curSearchResult.gender,
        startdate: this.curSearchResult.startDate,
        enddate: this.curSearchResult.endDate
      }, { responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const blobUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = 'searchResult.csv'
        link.click()
        URL.revokeObjectURL(blobUrl)
        miniToastr.success('匯出成功')
      }).catch((error) => {
        console.log('CATCH')
        console.log(error)
        this.$parent.Loading = false
        miniToastr.error(error.message, '匯出失敗')
      })
      this.$parent.Loading = false
    },
    getmemberone (mobile) {
      if (mobile === undefined || mobile === '') {
        this.model.extext = '請輸入手機號碼'
        return
      }
      if (this.model.phonetype) {
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/memberone/v1', {
        mobile: mobile
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.model.omobile = this.model.mobile
            this.member = response.data.member
            this.model.name = response.data.member.Name
            this.model.status = (response.data.member.Status === 1) ? '正常' : '黑名單停用'
            this.model.gender = (response.data.member.Gender === 'female') ? '女' : (response.data.member.Gender === 'male') ? '男' : (response.data.member.Gender === 'private') ? '不公開' : ''
            this.model.level = response.data.member.GradeText
            this.model.fistpoint = response.data.member.AvailableBonus
            this.model.lostpoint = response.data.member.AvailableBonus
            this.model.point = 0
            if (this.model.status !== '正常') {
              this.model.extext = '黑名單不可補點'
            } else {
              this.model.extext = ''
            }
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0007') {
            this.model.name = ''
            this.model.status = ''
            this.model.gender = ''
            this.model.level = ''
            this.model.extext = '查無此會員'
            this.model.fistpoint = 0
            this.model.lostpoint = 0
            this.model.point = 0
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '會員查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '會員查詢失敗')
          this.$parent.Loading = false
        })
    },
    CheckUser () {
      this.$refs.checkuser.show()
    },
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() - 3)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.model1.sdate = year + '-' + mon + '-' + day
      this.model1.edate = ''
    },
    Reset () {
      this.model1.status = '0'
      this.model1.gender = '0'
      this.model1.searchtext = ''
      this.setdate()
      this.model1.currentPage = 1
      this.sdateInvalid = false
      this.edateInvalid = false
      this.resetCurSearchResult()
      this.getmemberchangepointlist(1)
    },
    check_count (event) {
      var value = event.target.value
      if (!/^\+?[0-9]{10}$/.test(value) || (this.model.mobile !== this.model.omobile && this.model.omobile !== '')) {
        this.member = []
        this.model.name = ''
        this.model.status = ''
        this.model.gender = ''
        this.model.level = ''
        this.model.omobile = ''
        this.model.phonetype = true
      } else {
        this.model.phonetype = false
      }
    },
    changePoint (point) {
      if (point > 1000) {
        this.model.point = 1000
      } else if (point < -1000) {
        this.model.point = -1000
      } else {
        this.model.point = parseInt(this.model.point / 1)
      }
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: false
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
  },
  beforeMount: function () {
    this.setdate()
    this.getmemberchangepointlist(1)
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F08') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }

    this.querySelectListBrands();
  }
}
</script>
<style scoped>
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
    #mytable > tbody > tr > td {
        vertical-align: middle;
    }

    .table-break {
        word-break: break-all;
    /* table-layout:fixed; */
    }

    .text-nowrap > th {
      white-space: nowrap;
    }
    .broder {
      border-color: #004f2d !important;
      border-style: solid !important;
      border-width: 2px !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/recharge/List.vue